import api from "./api";
import Empresa from "../types/negocio/Empresa";
import BaseService from "./BaseService";

class EmpresaService extends BaseService<Empresa> {
  
  constructor() {
    super('empresa', api);
  }

  async getEmpresa(): Promise<Empresa> {
    return (await this.api.get(`/api/${this.route}/me`)).data;
  }

    
}

export const empresaService = new EmpresaService();